// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button.submitting[data-v-2161b39b]{padding-left:1em}button.submitting[data-v-2161b39b],button[disabled][data-v-2161b39b]{cursor:not-allowed;pointer-events:none}button[disabled][data-v-2161b39b]{background:#8da78f;box-shadow:0 .375em #7a8a7c;color:var(--colour-dark-green)}button[data-v-2161b39b]{position:relative}.spinner[data-v-2161b39b]{left:.8em;position:absolute;top:.6em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
